import { TemplateStore, ElementStore, MyLibraryStore, Tag, FilterObject, TPeriod } from './types';

class FetchedTab {
  public blocks: boolean;
  public template: boolean;
  public element: boolean;
  public mylibrary: boolean;
  public templateTags: boolean;

  constructor() {
    this.blocks = false;
    this.template = false;
    this.element = false;
    this.mylibrary = false;
    this.templateTags = false;
  }
}

export class State {
  public active: boolean;
  public activeTab: string;
  public blocks: {
    period: TPeriod;
    data: Array<any>;
  };
  public template: TemplateStore;
  public element: ElementStore;
  public mylibrary: MyLibraryStore;
  public fetchedTab: FetchedTab;
  public layout: string;
  public doInsertTemplate: boolean;
  public templateUseCase: Tag[];
  public industryData: Array<any>;
  public templateTags: any;
  public blockUseCase: Tag[];
  public filterObject: FilterObject;
  public countAddToPageLibrary: number;
  public numberUseAddToPage: number;
  public showShareLibraryOnBoarding: boolean;
  public showAddLibraryOnBoarding: { visible: boolean; type: string; target: any };

  constructor() {
    this.active = false;
    this.activeTab = 'templates';
    this.blocks = {
      data: [],
      period: {
        page: 1,
        pageSize: 30,
        refresh: false,
        loreMore: false,
        limited: false,
      },
    };
    this.element = new ElementStore();
    this.template = new TemplateStore();
    this.mylibrary = new MyLibraryStore();
    this.fetchedTab = new FetchedTab();
    this.doInsertTemplate = false;
    this.templateUseCase = [];
    this.industryData = [];
    this.templateTags = {};
    this.blockUseCase = [];
    this.showShareLibraryOnBoarding = false;
    this.showAddLibraryOnBoarding = { visible: false, type: '', target: null };
    this.countAddToPageLibrary = 0;
    this.numberUseAddToPage = 0;
    this.filterObject = {
      element: {},
      block: {},
      template: {},
      myLibrary: {},
    };

    this.layout = 'default';
  }
}

const state = new State();

export default state;
